import React from 'react';
import './Gallery.css'; 
import photo1 from './ImageGallery/1.jpg'
import photo2 from './ImageGallery/2.jpeg'
import photo3 from './ImageGallery/3.jpg'
import photo4 from './ImageGallery/4.jpg'
import photo5 from './ImageGallery/5.jpg'
import photo6 from './ImageGallery/6.jpg'
import photo7 from './ImageGallery/7.jpg'
import photo8 from './ImageGallery/8.jpg'
import photo9 from './ImageGallery/9.jpg'
import photo10 from './ImageGallery/10.jpg'
import photo11 from './ImageGallery/11.jpeg'
import photo12 from './ImageGallery/12.jpeg'
import photo13 from './ImageGallery/13.jpeg'
import photo14 from './ImageGallery/14.jpeg'
import photo15 from './ImageGallery/15.jpeg'
import photo16 from './ImageGallery/16.jpeg'
import photo17 from './ImageGallery/17.jpeg'

const   ImageGallery = () => {
  const images = [
    photo1,
    photo2,
    photo3,
    photo4,
    photo5,
    photo6,
    photo7,
    photo8,
    photo9,
    photo10,
    photo11,
    photo12,
    photo13,
    photo14,
    photo15,
    photo16,
    photo17
   ];

  return (
    <div className="gallery-container">
      <div className="card">
        <h2>School Photo Gallery</h2>
        <div className="image-grid">
          {images.map((src, index) => (
            <div className="image-item" key={index}>
              <img src={src} alt={`photo-${index + 1}`} className="image" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ImageGallery;
